import { render, staticRenderFns } from "./UserForOpenbadgePage.vue?vue&type=template&id=5ff459a0"
import script from "./UserForOpenbadgePage.vue?vue&type=script&lang=js"
export * from "./UserForOpenbadgePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports